export default (amount, currencyCode) => {
  const moneyFormatter = new Intl.NumberFormat([], {
    style: 'currency',
    currency: currencyCode,
  });

  return moneyFormatter.format(amount);
};

// Formats a number to the correct number of decimal places for that currency
export function formatMoneyNoSymbol(amount, currencyCode) {
  const info = new Intl.NumberFormat([], {
    style: 'currency',
    currency: currencyCode,
  }).resolvedOptions();

  const formatter = new Intl.NumberFormat(
    [],
    {
      minimumFractionDigits: info.minimumFractionDigits,
      maximumFractionDigits: info.maximumFractionDigits,
    },
  );

  return formatter.format(amount);
}

// Gets the symbol for the currency
export function getCurrencySymbol(currencyCode) {
  const formatter = new Intl.NumberFormat([], {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  return formatter.format(0).replace(/\d/g, '').trim();
}

/**
 * Source: https://stackoverflow.com/questions/29255843/is-there-a-way-to-reverse-the-formatting-by-intl-numberformat-in-javascript
 * Parse a localized number to a float.
 * @param {string} stringNumber - the localized number
 * @param {string} locale - [optional] the locale that the number is represented in. Omit this
 *    parameter to use the current locale.
 */
export function parseLocaleNumber(stringNumber, locale) {
  const thousandSeparator = Intl.NumberFormat(locale).format(11111).replace(/\p{Number}/gu, '');
  const decimalSeparator = Intl.NumberFormat(locale).format(1.1).replace(/\p{Number}/gu, '');

  return parseFloat(stringNumber
    .replace(new RegExp(`\\${thousandSeparator}`, 'g'), '')
    .replace(new RegExp(`\\${decimalSeparator}`), '.'));
}
